import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

const CustomScrollbars = props => (
	<Scrollbars
		style={props.style}
		className={props.className}
		autoHide={!props.showDefault}
		renderTrackHorizontal={props => <div {...props} style={{ display: 'none' }} className="track-horizontal" />}
		ref={ref => (props.onRef ? props.onRef(ref) : void 0)}
	>
		{props.children}
	</Scrollbars>
);

export default CustomScrollbars;



// WEBPACK FOOTER //
// ./util/CustomScrollbars.js